/*eslint no-lone-blocks: "error"*/
import React, { useContext, Suspense } from 'react';

import { Switch, RouteComponentProps } from 'react-router-dom';

import RouteWithSubRoutes from 'components/shared/RouteWithSubRoutes';
import LoadingSpinner from 'components/shared/LoadingSpinner';

import useBreadcrumbs from 'hooks/useBreadcrumbs';

import UserRoleContext from 'context/user-role/context';

import routes from './routes';

const ModelPortfolioRoute = ({ history }: RouteComponentProps) => {
  const { getAccessByMenu } = useContext(UserRoleContext);
  useBreadcrumbs(history, routes);
  return (
    <Suspense fallback={<LoadingSpinner />}>
      <Switch>
        {routes.map((route, i) => {
          return (
            getAccessByMenu(route) && (
              <RouteWithSubRoutes key={`${i}_${route.path}`} {...route} />
            )
          );
        })}
      </Switch>
    </Suspense>
  );
};

export default ModelPortfolioRoute;
